import { createSlice } from '@reduxjs/toolkit';
import * as actions from './actions';

const devicesSlice = createSlice({
	name: 'hotTopics',
	initialState: {
		hotTopicsLoaded: false,
		hotTopicsList: [],
	},
	extraReducers: (builder) => {
		builder.addCase(actions.getAllTopics.pending, (state) => {
			state.hotTopicsLoaded = false;
		});
			builder.addCase(actions.getAllTopics.fulfilled, (state, action) => {
				if (action.payload.success) {
					state.hotTopicsList = action.payload.data;
					state.hotTopicsLoaded = true;
				} else {
					console.log(action.payload.errorMessage);
				}
			});
			builder.addCase(actions.getAllTopics.rejected, (state) => {
				state.hotTopicsLoaded = false;
			});
	},
});

export default devicesSlice.reducer;